<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-card class="pa-4" elevation="4">
          <v-card-title>
            {{ isEditing ? 'Editar Cliente' : 'Novo Cliente' }}
          </v-card-title>

          <v-card-text>
            <v-tabs v-model="currentTab" dark class="mb-6">
              <v-tab value="details">Detalhes e Anúncio</v-tab>
            </v-tabs>

            <v-form ref="formRef" @submit.prevent="handleSubmit">
              <v-window v-model="currentTab" class="mt-2">
                <v-window-item value="details">

                  <h3 class="text-h6 mb-4 text-primary">Dados Básicos do Cliente</h3>
                  <v-row class="mt-2">
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="formValue.name" label="Nome / Razão Social" :rules="[rules.name]" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="formValue.document" v-maska="'##.###.###/####-##'"
                        label="CNPJ / CPF" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="formValue.email" label="Email" :rules="[rules.email]" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="formValue.phone" v-maska="'(##) #####-####'" label="WhatsApp" />
                    </v-col>
                  </v-row>

                  <v-divider class="my-6" />

                  <h3 class="text-h6 mb-4 text-primary">Anúncio Vinculado</h3>
                  <v-alert v-if="!formValue.advertisement" type="info" variant="tonal" class="mb-4">
                    Nenhum anúncio primário encontrado para este cliente.
                  </v-alert>

                  <div v-if="formValue.advertisement">
                    <v-row>
                      <v-col cols="12" sm="8">
                        <v-text-field label="Título do Anúncio" :model-value="formValue.advertisement.title" readonly
                          prepend-inner-icon="mdi-bullhorn" />
                      </v-col>
                      <v-col cols="12">
                      <v-textarea v-model="formValue.advertisement.description" label="Descrição" rows="2" />
                    </v-col>
                      <v-col cols="12" sm="2">
                        <v-text-field label="Código" :model-value="formValue.advertisement.code" readonly/>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-text-field label="Slug" :model-value="formValue.advertisement.slug" readonly
                          append-inner-icon="mdi-link" />
                      </v-col>

                      <v-col cols="12" sm="3">
                        <v-chip :color="adStatusMap[formValue.advertisement.status]" label>
                          Status: {{ formatAdStatus(formValue.advertisement.status) }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-chip :color="formValue.advertisement.is_active ? 'success' : 'error'" label>
                          Ativo: {{ formValue.advertisement.is_active ? 'Sim' : 'Não' }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field label="Publicação" :model-value="formatDate(formValue.advertisement.published_at)"
                          readonly prepend-inner-icon="mdi-calendar-check" />
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field label="Expira em" :model-value="formatDate(formValue.advertisement.expires_at)"
                          readonly prepend-inner-icon="mdi-calendar-remove" />
                      </v-col>
                    </v-row>
                  </div>

                  <v-divider class="my-6" />

                  <h3 class="text-h6 mb-4 text-primary">Plano de Assinatura</h3>
                  <v-alert 
                    v-if="!formValue.advertisement || !formValue.advertisement.subscription" 
                    type="warning" 
                    variant="tonal" 
                    class="mb-4"
                  >
                    Nenhuma assinatura ativa encontrada para este anúncio.
                  </v-alert>

                  <div v-if="formValue.advertisement && formValue.advertisement.subscription">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field 
                          label="Plano" 
                          :model-value="formValue.advertisement.subscription.name || 'N/A'" 
                          readonly
                          prepend-inner-icon="mdi-cash-register" 
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field 
                          label="Tipo de Plano"
                          :model-value="formatPlanType(formValue.advertisement.subscription.plan_type)" 
                          readonly
                          prepend-inner-icon="mdi-calendar-clock" 
                        />
                      </v-col>

                      <v-col cols="12" sm="3">
                        <v-text-field 
                          label="Valor" 
                          :model-value="formatCurrency(formValue.advertisement.subscription.amount)" 
                          readonly
                          prepend-inner-icon="mdi-currency-usd" 
                        />
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-chip 
                          :color="formValue.advertisement.subscription.is_active ? 'success' : 'error'" 
                          label
                        >
                          Status Assinatura: {{ formValue.advertisement.subscription.is_active ? 'Ativa' : 'Cancelada' }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field 
                          label="Início da Assinatura"
                          :model-value="formatDate(formValue.advertisement.subscription.start_at)" 
                          readonly
                          prepend-inner-icon="mdi-calendar-plus" 
                        />
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field 
                          label="Próxima Cobrança"
                          :model-value="formatDate(formValue.advertisement.subscription.next_billing_at)" 
                          readonly
                          prepend-inner-icon="mdi-calendar-alert" 
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <v-divider class="my-6" />

                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-switch v-model="formValue.is_active" color="success" label="Cliente Ativo?" />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select v-model="formValue.payment_status" :items="paymentStatusOptions" item-title="label"
                        item-value="value" label="Status do Último Pagamento" />
                    </v-col>
                  </v-row>
                </v-window-item>
              </v-window>
            </v-form>
          </v-card-text>

          <v-card-actions class="d-flex justify-space-between">
            <v-btn color="secondary" variant="flat" @click="handleCancel">
              <v-icon start>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
            <v-btn color="primary" variant="flat" :loading="isSubmitting" :disabled="isSubmitting"
              @click="handleSubmit">
              <v-icon start>mdi-content-save</v-icon>
              {{ isEditing ? 'Salvar Alterações do Cliente' : 'Cadastrar Cliente' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { vMaska } from "maska/vue";
import api from '@/services/api';
import { useToastStore } from '@/store/toast';
import { useLoadingStore } from '@/store/loadingStore';

const toastStore = useToastStore();
const loadingStore = useLoadingStore();
const route = useRoute();
const router = useRouter();
const formRef = ref(null);

const isEditing = computed(() => !!route.params.id);
const isSubmitting = ref(false);
const currentTab = ref('details');

// 💡 ADIÇÕES PARA CORRIGIR O ERRO: Definição de adStatusMap e paymentStatusOptions
const adStatusMap = {
  in_analysis: 'warning',
  approved: 'success',
  expired: 'error',
  rejected: 'red-darken-4'
};

const paymentStatusOptions = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Pago', value: 'paid' },
  { label: 'Expirado', value: 'expired' },
];

// Variável que você pode ter removido, mas que é usada na estrutura inicial
const enterpriseOptions = ref([]); 
// Você removeu o campo <v-select> do template, então esta variável não é estritamente necessária aqui, mas se for adicioná-lo de volta, você precisará dela.

const formValue = ref({
  name: '',
  document: '',
  email: '',
  phone: '',
  whatsapp: '',
  description: '',
  zip_code: '', 
  address: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  payment_status: 'pending',
  is_active: true,
  enterprise_id: null,
  advertisement: null, 
});

// Regras de validação 
const rules = {
  name: v => !!v || 'O nome é obrigatório.',
  email: v => !v || /.+@.+\..+/.test(v) || 'O email deve ser válido.',
};

function formatPlanType(type) {
  const map = {
    monthly: 'Mensal',
    'semi-annual': 'Semestral',
    annual: 'Anual'
  };
  return map[type] || type;
}

function formatAdStatus(status) {
    if (!status) return 'N/A';
    const statusMap = {
        in_analysis: 'Em Análise',
        approved: 'Aprovado',
        expired: 'Expirado',
        rejected: 'Rejeitado'
    };
    return statusMap[status] || status;
}

function formatCurrency(amount) {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(amount));
}

function formatDate(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date)) return 'N/A';
  return date.toLocaleDateString('pt-BR');
}

const loadClient = async (id) => {
  loadingStore.show();
  try {
    const response = await api.get(`/clients/${id}`);
    const data = response.data.data;

    if (!data) {
      toastStore.showToast({ message: 'O cliente não foi encontrado.', color: 'warning' });
      return;
    }
    
    const { subscription, ...clientData } = data; 

    formValue.value = {
      ...formValue.value,
      ...clientData,
      is_active: data.is_active === 1 || data.is_active === true,
      
      advertisement: data.advertisement || null, 
    };

  } catch (error) {
    console.error('Erro ao carregar os dados do cliente:', error);
    toastStore.showToast({ message: error?.response?.data?.error || 'Erro ao carregar os dados do cliente.', color: 'error' });
  } finally {
    loadingStore.hide();
  }
};

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) return;

  isSubmitting.value = true;
  const payload = { ...formValue.value };

  delete payload.advertisement;
  
  if (payload.document) payload.document = String(payload.document).replace(/\D/g, '');
  if (payload.phone) payload.phone = String(payload.phone).replace(/\D/g, '');
  if (payload.whatsapp) payload.whatsapp = String(payload.whatsapp).replace(/\D/g, '');
  
  payload.is_active = payload.is_active ? 1 : 0;
  
  try {
    if (isEditing.value) {
      await api.put(`/clients/${route.params.id}`, payload);
    } else {
      await api.post('/clients', payload);
    }

    router.push('/app/clientes'); 
    toastStore.showToast({
      message: isEditing.value ? 'Cliente atualizado com sucesso!' : 'Cliente cadastrado com sucesso!',
      color: 'success',
    });
  } catch (error) {
    console.error('Erro ao salvar cliente:', error);
    toastStore.showToast({ message: error?.response?.data?.error || 'Erro ao salvar cliente.', color: 'error' });
  } finally {
    isSubmitting.value = false;
  }
};

const handleCancel = () => { router.push('/app/clientes'); };

onMounted(() => {
  if (isEditing.value) {
    loadClient(route.params.id);
  }
});
</script>

<style scoped>
/* Estilos mantidos do modelo */
</style>